import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "report-timestamp" }
const _hoisted_2 = { class: "report-timestamp__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Clock = _resolveComponent("Clock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createTextVNode(" Timestamp ", -1 /* CACHED */)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(_component_el_icon, { class: "report-timestamp__info-icon" }, {
        default: _withCtx(() => [
          _createVNode(_component_Clock)
        ]),
        _: 1 /* STABLE */
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.timestamp), 1 /* TEXT */)
    ])), [
      [_directive_loading, _ctx.isTimestampLoading]
    ])
  ]))
}